export const getSubmitButtonText = ({
    calculation,
    prefix
}) => {
    if (!calculation?.price) {
        return prefix;
    }

    const {price, discount = 0} = calculation;
    const {sendAmount = 0, fees = 0, sendCurrencyCode = ''} = price;
    const totalPay = sendAmount + fees - discount;

    if (totalPay > 0) {
        return `${prefix} ${totalPay.toFixed(2)} ${sendCurrencyCode}`;
    }

    return prefix;
};
